import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import PublicNavBar from '../../components/PublicNavBar';
import PortalFooter from '../../components/PortalFooter';
import { contentAPI } from '../../services/api';

const DEFAULT = `Haben Sie Fragen oder Anregungen? Wir freuen uns über Ihre Nachricht.

Callcenter-Suche
Musterstraße 123, 12345 Musterstadt
Tel: +49 (0) 123 456789
E-Mail: info@callcenter-suche.de

Geschäftszeiten
Montag bis Freitag: 09:00 - 17:00 Uhr

Technischer Support
Für technische Unterstützung kontaktieren Sie bitte: support@callcenter-suche.de`;

const ContactPage: React.FC = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    contentAPI.getAll()
      .then((res) => setContent(res.data.data?.content_contact || DEFAULT))
      .catch(() => setContent(DEFAULT))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
      <PublicNavBar />
      <Container maxWidth="lg" sx={{ py: 6, flex: 1 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 4 }}>
          Kontakt
        </Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 1.9 }}>
            {content}
          </Typography>
        )}
      </Container>
      <PortalFooter />
    </Box>
  );
};

export default ContactPage;
